import React from "react";
import { NavLink } from "react-router-dom";
import "../../../css/Topbar.css";

const Topbar: React.FC = () => {
  return (
    <nav className="admin-center-topbar">
      <NavLink
        to="/questionnaire"
        className={({ isActive }) => (isActive ? "admin-center-tab active" : "admin-center-tab")}
      >
        Questions
      </NavLink>
      <NavLink
        to="/histories"
        className={({ isActive }) => (isActive ? "admin-center-tab active" : "admin-center-tab")}
      >
        Histories
      </NavLink>
    </nav>
  );
};

export default Topbar;
